export const getFirstLetter = (name = '') => (name[0] || '')
